import { MUIViewController } from "./MUIViewController";

export class MUIReportViewController extends MUIViewController
{
    private _tableView = null;
}